module.exports = __webpack_public_path__ + "static/hands-dbfb587716dc982719dc7794ca8aa6df.jpg";